import { TemplateStringParameterValue } from '~/scenes/Automation/Flows/Actions/Base/types.flow';

import { PARAMETER_VALUE_TYPE } from '../constants';

export default (): TemplateStringParameterValue => ({
  template: '',
  mappings: [],
  type: PARAMETER_VALUE_TYPE.TEMPLATE_STRING,
});
